export default "__VITE_ASSET__DghghPcD__"